import { IStatusInfo } from '@olymp/shared';
import { ApplicationStatus } from './status-enum';

export const ApplicationStatusesStyles: IStatusInfo[] = [
  {
    status: ApplicationStatus.Created,
    color: '#15803d',
    backgroundColor: '#dcfce7',
  },
  {
    status: ApplicationStatus.Rejected,
    color: '#b91c1c',
    backgroundColor: '#fee2e2',
  },
  {
    status: ApplicationStatus.Approved,
    color: '#065f46',
    backgroundColor: '#d1fae5',
  },
  {
    status: ApplicationStatus.Qualified,
    color: '#16a34a',
    backgroundColor: '#d1fae5',
  },
  {
    status: ApplicationStatus.NotQualified,
    color: '#b91c1c',
    backgroundColor: '#fee2e2',
  },
  {
    status: ApplicationStatus.Absent,
    color: '#134e4a',
    backgroundColor: '#ccfbf1',
  },
  {
    status: ApplicationStatus.Disqualified,
    color: '#b91c1c',
    backgroundColor: '#fef3c7',
  },
];

export const ApplicationStatusStyles: IStatusInfo[] = [
  {
    status: ApplicationStatus.Created,
    color: '#15803d',
    backgroundColor: '#dcfce7',
  },
  {
    status: ApplicationStatus.Rejected,
    color: '#b91c1c',
    backgroundColor: '#fee2e2',
  },
  {
    status: ApplicationStatus.Absent,
    color: '#15803d',
    backgroundColor: '#d1fae5',
  },
  {
    status: ApplicationStatus.Approved,
    color: '#15803d',
    backgroundColor: '#dcfce7',
  },
];
